module.exports = __webpack_public_path__ + "static/media/poll.c0e0cc12.svg";